import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import feather from 'vue-icon'
import Print from 'vue-print-nb'
import moment from "moment"
import VueToastr from "vue-toastr"
import Vuelidate from  'vuelidate'
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Multiselect from 'vue-multiselect';
// plugins/vue-js-modal.js
import VModal from 'vue-js-modal/dist/ssr.nocss'
import 'vue-js-modal/dist/styles.css'

Vue.use(VModal, {})

Vue.config.productionTip = false

// use plugin
Vue.use(VueToastr, {});
Vue.use(Print);
Vue.use(feather, 'v-icon')
Vue.use(Vuelidate)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts);
Vue.component('multiselect', Multiselect)

Vue.prototype.$http = axios
Vue.prototype.moment = moment

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'Ngn',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

 //Vue.prototype.$urlAuth = "http://whtstage.revotax.com:3010/api/v1/admin";    //local server
// Vue.prototype.$urlAuth = "http://localhost:3010/api/v1/admin";          //laptop server
 Vue.prototype.$urlAuth = "https://wht.revotax.com/api/v1/admin";        //live server
// Vue.prototype.$urlAuth = "http://192.168.88.18:3010/api/v1/admin";         //laptop server

 //Vue.prototype.$urlUpload = "http://105.112.130.227:4004/withholding";     //local server
Vue.prototype.$urlUpload = "https://wht.revotax.com/withholding";        //live server
// Vue.prototype.$urlUpload = "http://localhost:4004/withholding";            //laptop server

//  Vue.prototype.$urlBene = "http://localhost:3213/api/v1/beneficiary";      //laptop server
//Vue.prototype.$urlBene = "http://105.112.130.227:3213/api/v1/beneficiary";    //local server
 Vue.prototype.$urlBene = "https://wht.revotax.com/api/v1/beneficiary";     //live server
// Vue.prototype.$urlBene = "http://192.168.88.18:3010/api/v1/beneficiary";    //laptop server

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
